module.exports = __webpack_public_path__ + "img/dcs_pic_6.c6fdea58.jpg";